export enum RouletteType {
  Default = 'default',
  Infinity = 'infinity',
}
